import React from "react";

export function Cursor() {
  return (
    <div className="g-cursor" js-cursor="true">
      <div className="g-cursor__product">
        <span></span>
        <div className="g-cursor__product-title">
          <div></div>
        </div>
        <div className="g-cursor__product-author">
          <div></div>
        </div>
      </div>
    </div>
  );
}
